module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "supplier-sidebar",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticClass: "component-padding",
    attrs: {
      "id": "myproduct"
    }
  }, [_c('p', {
    staticClass: "header-type-e"
  }, [_vm._v("Product: 6SGHA14")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "id": "ex1"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": "static/images/j.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product-data"
  }, [_c('h2', [_vm._v("Product Info")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Description")])]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("Chase red laser dot eat half my food and ask for more. Make muffins if it fits, i sits meow meow chase red.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Price")]), _vm._v(" Php 140.00")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product-data"
  }, [_c('h2', [_vm._v("Product Specs")]), _vm._v(" "), _c('ul', {
    staticClass: "product-specs"
  }, [_c('li', [_c('strong', [_vm._v("Box Dimension (cm)")]), _vm._v(" 7 x 7 x 7")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Item Dimension (cm)")]), _vm._v(" 7 x 7 x 7")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Design")]), _vm._v(" Classic")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Materials")]), _vm._v(" Acrylic")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Socket Type")]), _vm._v(" E12")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Finish")]), _vm._v(" Antique Brass")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Category")]), _vm._v(" Bulbs")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Place")]), _vm._v(" Aisle")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Ceiling")]), _vm._v(" High Ceiling")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("I/O")]), _vm._v(" Indoor")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("LED")]), _vm._v(" LED Capable")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "padding-bottom": "40px"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f92dd43"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SupplierProduct.vue
// module id = 148
// module chunks = 0